export default {"src":"/_next/static/image/src/images/Icons/search.0aa71e0107a578737601b5368d163c6e.svg","height":19,"width":19};